import { useQuery } from "@tanstack/react-query";
import { AutoCompleteKeyword, Page } from "@/model";
import autoCompleteKeywordRepository from "@/repository/autoCompleteKeywordRepository";


const getData = async (
    agentId: number,
    autocompleteId: string,
    page: number,
    size: number,
    order: 'asc' | 'desc',
    keyword?: string
) => {
    const res = await autoCompleteKeywordRepository.find(agentId, autocompleteId, page, size, order, keyword);
    return res.data?.data;
};

export const usePaginatedAutocompleteKeywords = (
    agentId: number,
    autocompleteId: string,
    page: number,
    size: number,
    order: 'asc' | 'desc',
    keyword?: string
) => {
    return useQuery<Page<AutoCompleteKeyword>>({
        queryKey: ['autocomplete-keyword', 'agent', agentId, autocompleteId, page, size, order, keyword],
        queryFn: async () => getData(agentId,autocompleteId, page, size, order, keyword),
        retry: false
    });
};
